import React from 'react';

const LinearProgress: React.FC = () => {
  return (
    <div className='relative w-full h-[3px] bg-white-200 overflow-hidden'>
      <div className='custom-slide' style={{ animationDuration: '2s' }} />
    </div>
  );
};

export default LinearProgress;
